const INTERVAL_ENUM = {
  NONE: {
    label: 'none',
    value: 0
  },
  CUSTOM: {
    label: 'custom',
    value: 0
  },
  ONE_HOUR: {
    label: 'one_hour',
    value: 60
  },
  TWELVE_HOURS: {
    label: 'twelve_hours',
    value: 720
  },
  ONE_DAY: {
    label: 'one_day',
    value: 1440
  },
  ONE_WEEK: {
    label: 'one_week',
    value: 10080
  },
  FIFTEEN_DAYS: {
    label: 'fifteen_days',
    value: 21600
  },
  ONE_MONTH: {
    label: 'one_month',
    value: 43200
  }
}
const EXPIRES_IN_PERIOD = {
  YEARS: {
    label: 'years',
    value: 525960
  },
  MONTHS: {
    label: 'months',
    value: 43800
  },
  WEEKS: {
    label: 'weeks',
    value: 10080
  },
  DAYS: {
    label: 'days',
    value: 1440
  },
  HOURS: {
    label: 'hours',
    value: 60
  },
  MINUTES: {
    label: 'minutes',
    value: 1
  }
}
export { INTERVAL_ENUM, EXPIRES_IN_PERIOD }
